<template>
    <transition>
        <div class="new_main">
            <div class="title borderNone">
                <span @click="goHome">首页</span> > <span @click="goNewsList">企业资讯</span>  > 资讯详情
            </div>
            <div class="new_ul">
                <div class="new_title">{{detailList.title}}</div>
                <div class="new_time" v-if="detailList.release_time">{{detailList.release_time | formatDate}}</div>
                <div class="new_con">
                    <p v-html="detailList.content">
                    </p>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import { formatDate } from '@/assets/js/date.js'
export default {
    data() {
        return {
            id: this.$route.params.id,
            detailList:{}
        };
    },
    filters: {
        formatDate: function(time) {
            var date = new Date(time);
            return formatDate(date, 'yyyy-MM-dd');
        }
    },
    mounted() {
        this.getNewsDetail(this.id);
    },
    beforeDestroy() {},
    methods: {
        goHome: function () {
            this.$router.push({ path: "/" });
        },
        goNewsList: function () {
            this.$router.push({ path: "/news" });
        },
        getNewsDetail: function(id) {
            let datas={
                "id":id
            };
            this.getHttp(this, datas, '/front/news/info	', function (obj, data) {
                // let data_ = data.data;
                obj.detailList = data.data;
                console.log("资讯详情",data_);
                // obj.newsList = data_.data_list;
                // obj.total = data_.total;
            })
        }
    }
};
</script>
<style scope lang="scss">
.new_main {
    width: 100%;
    min-height: 9rem;
    background: url("../assets/pcImg/new/bg.jpg") no-repeat;
    background-size: 100% 100%;
    position: relative;
    .title {
        width: 12rem;
        height: 1rem;
        line-height: 1rem;
        padding-left: 0.5rem;
        position: absolute;
        top: 1.3rem;
        left: 50%;
        z-index: 999;
        margin-left: -6rem;
        color: white;
        font-size: 0.16rem;
        border-bottom: 2px solid #383c44;
        cursor: pointer;
        span{
            &:hover{
                color:#f08200
            }
        }
    }
    .borderNone {
        border-bottom: none;
        span{
            cursor: pointer;
        }
    }
    .n_title {
        text-align: center;
    }
    .new_ul {
        width: 12rem;
        position: relative;
        left: 50%;
        margin-left: -6rem;
        list-style: none;
        font-size: 0.14rem;
        color: #fff;
        padding-top: 2.03rem;
        padding-bottom: .4rem;
        .new_title {
            color: #fff;
            text-align: center;
            font-size: 0.42rem;
        }
        .new_time {
            color:#b3b2b1;
            font-size: 0.2rem;
            text-align: right;
            margin-top: 34px;
            padding-bottom: 14px;
            border-bottom: 2px solid #383c44;
        }
        .new_con {
            padding-top: 40px;
            font-size: 0.18rem;
            line-height: .25rem;
            text-align: left;
            font-family: '黑体' !important;
            cursor: default;
            p{
                text-indent: 2em;
            }
            img{
                margin: .2rem auto auto;
            }
        }
        li {
            width: 100%;
            border-bottom: 1px solid #383c44;
            padding: 0.4rem;
            position: relative;
            cursor: pointer;
            z-index: 0;
            .new_title {
                color: white;
                font-size: 0.22rem;
                width: 80%;
                float: left;
                height: 0.6rem;
                line-height: 0.6rem;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
            }
            .new_date {
                color: #b3b2b1;
                font-size: 0.18rem;
                width: 20%;
                float: left;
                height: 0.6rem;
                line-height: 0.6rem;
                text-align: right;
            }
            .new_detail {
                color: #b3b2b1;
                font-size: 0.16rem;
                width: 80%;
                float: left;
                height: 0.4rem;
                line-height: 0.4rem;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
            }
        }
        li i {
            width: 0;
            height: 1px;
            content: "";
            background-color: #f08200;
            position: absolute;
            left: 50%;
            right: 50%;
            bottom: 0%;
            transition: all 0.7s;
            z-index: -1;
        }
        li:hover i {
            width: 100%;
            right: 0%;
            bottom: 0%;
            left: 0%;
        }
    }
    .new_page {
        width: 12rem;
        position: absolute;
        bottom: -0.5rem;
        left: 50%;
        margin-left: -6rem;
        text-align: center;
    }
}
</style>